module.exports = __webpack_public_path__ + "static/media/Web_demo_telehealth.c9f07425.jpg";